const COUNTRY = [
  { 'code': 'AF', 'name': 'Afghanistan' },
  { 'code': 'AX', 'name': 'Aland Islands' },
  { 'code': 'AL', 'name': 'Albania' },
  { 'code': 'DZ', 'name': 'Algeria' },
  { 'code': 'AS', 'name': 'American Samoa' },
  { 'code': 'AD', 'name': 'Andorra' },
  { 'code': 'AO', 'name': 'Angola' },
  { 'code': 'AI', 'name': 'Anguilla' },
  { 'code': 'AQ', 'name': 'Antarctica' },
  { 'code': 'AG', 'name': 'Antigua and Barbuda' },
  { 'code': 'AR', 'name': 'Argentina' },
  { 'code': 'AM', 'name': 'Armenia' },
  { 'code': 'AW', 'name': 'Aruba' },
  { 'code': 'AU', 'name': 'Australia' },
  { 'code': 'AT', 'name': 'Austria' },
  { 'code': 'AZ', 'name': 'Azerbaijan' },
  { 'code': 'BS', 'name': 'Bahamas, The' },
  { 'code': 'BH', 'name': 'Bahrain' },
  { 'code': 'BD', 'name': 'Bangladesh' },
  { 'code': 'BB', 'name': 'Barbados' },
  { 'code': 'BY', 'name': 'Belarus' },
  { 'code': 'BE', 'name': 'Belgium' },
  { 'code': 'BZ', 'name': 'Belize' },
  { 'code': 'BJ', 'name': 'Benin' },
  { 'code': 'BM', 'name': 'Bermuda' },
  { 'code': 'BT', 'name': 'Bhutan' },
  { 'code': 'BO', 'name': 'Bolivia' },
  { 'code': 'BQ', 'name': 'Bonaire, Saint Eustatius and Saba' },
  { 'code': 'BA', 'name': 'Bosnia and Herzegovina' },
  { 'code': 'BW', 'name': 'Botswana' },
  { 'code': 'BV', 'name': 'Bouvet Island' },
  { 'code': 'BR', 'name': 'Brazil' },
  { 'code': 'IO', 'name': 'British Indian Ocean Territory' },
  { 'code': 'BN', 'name': 'Brunei Darussalam' },
  { 'code': 'BG', 'name': 'Bulgaria' },
  { 'code': 'BF', 'name': 'Burkina Faso' },
  { 'code': 'BI', 'name': 'Burundi' },
  { 'code': 'KH', 'name': 'Cambodia' },
  { 'code': 'CM', 'name': 'Cameroon' },
  { 'code': 'CA', 'name': 'Canada' },
  { 'code': 'CV', 'name': 'Cape Verde' },
  { 'code': 'KY', 'name': 'Cayman Islands' },
  { 'code': 'CF', 'name': 'Central African Republic' },
  { 'code': 'TD', 'name': 'Chad' },
  { 'code': 'CL', 'name': 'Chile' },
  { 'code': 'CN', 'name': 'China' },
  { 'code': 'CX', 'name': 'Christmas Island' },
  { 'code': 'CC', 'name': 'Cocos (Keeling) Islands' },
  { 'code': 'CO', 'name': 'Colombia' },
  { 'code': 'KM', 'name': 'Comoros' },
  { 'code': 'CG', 'name': 'Congo' },
  { 'code': 'CD', 'name': 'Congo, The Democratic Republic of the' },
  { 'code': 'CK', 'name': 'Cook Islands' },
  { 'code': 'CR', 'name': 'Costa Rica' },
  { 'code': 'CI', 'name': "Cote D'ivoire" },
  { 'code': 'HR', 'name': 'Croatia' },
  { 'code': 'CW', 'name': 'CuraĂ§ao' },
  { 'code': 'CY', 'name': 'Cyprus' },
  { 'code': 'CZ', 'name': 'Czech Republic' },
  { 'code': 'DK', 'name': 'Denmark' },
  { 'code': 'DJ', 'name': 'Djibouti' },
  { 'code': 'DM', 'name': 'Dominica' },
  { 'code': 'DO', 'name': 'Dominican Republic' },
  { 'code': 'EC', 'name': 'Ecuador' },
  { 'code': 'EG', 'name': 'Egypt' },
  { 'code': 'SV', 'name': 'El Salvador' },
  { 'code': 'GQ', 'name': 'Equatorial Guinea' },
  { 'code': 'ER', 'name': 'Eritrea' },
  { 'code': 'EE', 'name': 'Estonia' },
  { 'code': 'ET', 'name': 'Ethiopia' },
  { 'code': 'FK', 'name': 'Falkland Islands (Malvinas)' },
  { 'code': 'FO', 'name': 'Faroe Islands' },
  { 'code': 'FJ', 'name': 'Fiji' },
  { 'code': 'FI', 'name': 'Finland' },
  { 'code': 'FR', 'name': 'France' },
  { 'code': 'GF', 'name': 'French Guiana' },
  { 'code': 'PF', 'name': 'French Polynesia' },
  { 'code': 'TF', 'name': 'French Southern Territories' },
  { 'code': 'GA', 'name': 'Gabon' },
  { 'code': 'GM', 'name': 'Gambia, The' },
  { 'code': 'GE', 'name': 'Georgia' },
  { 'code': 'DE', 'name': 'Germany' },
  { 'code': 'GH', 'name': 'Ghana' },
  { 'code': 'GI', 'name': 'Gibraltar' },
  { 'code': 'GR', 'name': 'Greece' },
  { 'code': 'GL', 'name': 'Greenland' },
  { 'code': 'GD', 'name': 'Grenada' },
  { 'code': 'GP', 'name': 'Guadeloupe' },
  { 'code': 'GU', 'name': 'Guam' },
  { 'code': 'GT', 'name': 'Guatemala' },
  { 'code': 'GG', 'name': 'Guernsey' },
  { 'code': 'GN', 'name': 'Guinea' },
  { 'code': 'GW', 'name': 'Guinea-Bissau' },
  { 'code': 'GY', 'name': 'Guyana' },
  { 'code': 'HT', 'name': 'Haiti' },
  { 'code': 'HM', 'name': 'Heard Island and the McDonald Islands' },
  { 'code': 'VA', 'name': 'Holy See' },
  { 'code': 'HN', 'name': 'Honduras' },
  { 'code': 'HK', 'name': 'Hong Kong' },
  { 'code': 'HU', 'name': 'Hungary' },
  { 'code': 'IS', 'name': 'Iceland' },
  { 'code': 'IN', 'name': 'India' },
  { 'code': 'ID', 'name': 'Indonesia' },
  { 'code': 'IQ', 'name': 'Iraq' },
  { 'code': 'IE', 'name': 'Ireland' },
  { 'code': 'IM', 'name': 'Isle of Man' },
  { 'code': 'IL', 'name': 'Israel' },
  { 'code': 'IT', 'name': 'Italy' },
  { 'code': 'JM', 'name': 'Jamaica' },
  { 'code': 'JP', 'name': 'Japan' },
  { 'code': 'JE', 'name': 'Jersey' },
  { 'code': 'JO', 'name': 'Jordan' },
  { 'code': 'KZ', 'name': 'Kazakhstan' },
  { 'code': 'KE', 'name': 'Kenya' },
  { 'code': 'KI', 'name': 'Kiribati' },
  { 'code': 'KR', 'name': 'Korea, Republic of' },
  { 'code': 'XK', 'name': 'Kosovo' },
  { 'code': 'KW', 'name': 'Kuwait' },
  { 'code': 'KG', 'name': 'Kyrgyzstan' },
  { 'code': 'LA', 'name': "Lao People's Democratic Republic" },
  { 'code': 'LV', 'name': 'Latvia' },
  { 'code': 'LB', 'name': 'Lebanon' },
  { 'code': 'LS', 'name': 'Lesotho' },
  { 'code': 'LR', 'name': 'Liberia' },
  { 'code': 'LY', 'name': 'Libya' },
  { 'code': 'LI', 'name': 'Liechtenstein' },
  { 'code': 'LT', 'name': 'Lithuania' },
  { 'code': 'LU', 'name': 'Luxembourg' },
  { 'code': 'MO', 'name': 'Macao' },
  { 'code': 'MK', 'name': 'Macedonia, The Former Yugoslav Republic of' },
  { 'code': 'MG', 'name': 'Madagascar' },
  { 'code': 'MW', 'name': 'Malawi' },
  { 'code': 'MY', 'name': 'Malaysia' },
  { 'code': 'MV', 'name': 'Maldives' },
  { 'code': 'ML', 'name': 'Mali' },
  { 'code': 'MT', 'name': 'Malta' },
  { 'code': 'MH', 'name': 'Marshall Islands' },
  { 'code': 'MQ', 'name': 'Martinique' },
  { 'code': 'MR', 'name': 'Mauritania' },
  { 'code': 'MU', 'name': 'Mauritius' },
  { 'code': 'YT', 'name': 'Mayotte' },
  { 'code': 'MX', 'name': 'Mexico' },
  { 'code': 'FM', 'name': 'Micronesia, Federated States of' },
  { 'code': 'MD', 'name': 'Moldova, Republic of' },
  { 'code': 'MC', 'name': 'Monaco' },
  { 'code': 'MN', 'name': 'Mongolia' },
  { 'code': 'ME', 'name': 'Montenegro' },
  { 'code': 'MS', 'name': 'Montserrat' },
  { 'code': 'MA', 'name': 'Morocco' },
  { 'code': 'MZ', 'name': 'Mozambique' },
  { 'code': 'MM', 'name': 'Myanmar' },
  { 'code': 'NA', 'name': 'Namibia' },
  { 'code': 'NR', 'name': 'Nauru' },
  { 'code': 'NP', 'name': 'Nepal' },
  { 'code': 'NL', 'name': 'Netherlands' },
  { 'code': 'AN', 'name': 'Netherlands Antilles' },
  { 'code': 'NC', 'name': 'New Caledonia' },
  { 'code': 'NZ', 'name': 'New Zealand' },
  { 'code': 'NI', 'name': 'Nicaragua' },
  { 'code': 'NE', 'name': 'Niger' },
  { 'code': 'NG', 'name': 'Nigeria' },
  { 'code': 'NU', 'name': 'Niue' },
  { 'code': 'NF', 'name': 'Norfolk Island' },
  { 'code': 'MP', 'name': 'Northern Mariana Islands' },
  { 'code': 'NO', 'name': 'Norway' },
  { 'code': 'OM', 'name': 'Oman' },
  { 'code': 'PK', 'name': 'Pakistan' },
  { 'code': 'PW', 'name': 'Palau' },
  { 'code': 'PS', 'name': 'Palestinian Territories' },
  { 'code': 'PA', 'name': 'Panama' },
  { 'code': 'PG', 'name': 'Papua New Guinea' },
  { 'code': 'PY', 'name': 'Paraguay' },
  { 'code': 'PE', 'name': 'Peru' },
  { 'code': 'PH', 'name': 'Philippines' },
  { 'code': 'PN', 'name': 'Pitcairn' },
  { 'code': 'PL', 'name': 'Poland' },
  { 'code': 'PT', 'name': 'Portugal' },
  { 'code': 'PR', 'name': 'Puerto Rico' },
  { 'code': 'QA', 'name': 'Qatar' },
  { 'code': 'RE', 'name': 'Reunion' },
  { 'code': 'RO', 'name': 'Romania' },
  { 'code': 'RU', 'name': 'Russian Federation' },
  { 'code': 'RW', 'name': 'Rwanda' },
  { 'code': 'BL', 'name': 'Saint Barthelemy' },
  { 'code': 'SH', 'name': 'Saint Helena, Ascension and Tristan da Cunha' },
  { 'code': 'KN', 'name': 'Saint Kitts and Nevis' },
  { 'code': 'LC', 'name': 'Saint Lucia' },
  { 'code': 'MF', 'name': 'Saint Martin' },
  { 'code': 'PM', 'name': 'Saint Pierre and Miquelon' },
  { 'code': 'VC', 'name': 'Saint Vincent and the Grenadines' },
  { 'code': 'WS', 'name': 'Samoa' },
  { 'code': 'SM', 'name': 'San Marino' },
  { 'code': 'ST', 'name': 'Sao Tome and Principe' },
  { 'code': 'SA', 'name': 'Saudi Arabia' },
  { 'code': 'SN', 'name': 'Senegal' },
  { 'code': 'RS', 'name': 'Serbia' },
  { 'code': 'SC', 'name': 'Seychelles' },
  { 'code': 'SL', 'name': 'Sierra Leone' },
  { 'code': 'SG', 'name': 'Singapore' },
  { 'code': 'SX', 'name': 'Sint Maarten' },
  { 'code': 'SK', 'name': 'Slovakia' },
  { 'code': 'SI', 'name': 'Slovenia' },
  { 'code': 'SB', 'name': 'Solomon Islands' },
  { 'code': 'SO', 'name': 'Somalia' },
  { 'code': 'ZA', 'name': 'South Africa' },
  { 'code': 'GS', 'name': 'South Georgia and the South Sandwich Islands' },
  { 'code': 'ES', 'name': 'Spain' },
  { 'code': 'LK', 'name': 'Sri Lanka' },
  { 'code': 'SR', 'name': 'Suriname' },
  { 'code': 'SJ', 'name': 'Svalbard and Jan Mayen' },
  { 'code': 'SZ', 'name': 'Swaziland' },
  { 'code': 'SE', 'name': 'Sweden' },
  { 'code': 'CH', 'name': 'Switzerland' },
  { 'code': 'TW', 'name': 'Taiwan' },
  { 'code': 'TJ', 'name': 'Tajikistan' },
  { 'code': 'TZ', 'name': 'Tanzania, United Republic of' },
  { 'code': 'TH', 'name': 'Thailand' },
  { 'code': 'TL', 'name': 'Timor-leste' },
  { 'code': 'TG', 'name': 'Togo' },
  { 'code': 'TK', 'name': 'Tokelau' },
  { 'code': 'TO', 'name': 'Tonga' },
  { 'code': 'TT', 'name': 'Trinidad and Tobago' },
  { 'code': 'TN', 'name': 'Tunisia' },
  { 'code': 'TR', 'name': 'Turkey' },
  { 'code': 'TM', 'name': 'Turkmenistan' },
  { 'code': 'TC', 'name': 'Turks and Caicos Islands' },
  { 'code': 'TV', 'name': 'Tuvalu' },
  { 'code': 'UG', 'name': 'Uganda' },
  { 'code': 'UA', 'name': 'Ukraine' },
  { 'code': 'AE', 'name': 'United Arab Emirates' },
  { 'code': 'GB', 'name': 'United Kingdom' },
  { 'code': 'US', 'name': 'United States' },
  { 'code': 'UM', 'name': 'United States Minor Outlying Islands' },
  { 'code': 'UY', 'name': 'Uruguay' },
  { 'code': 'UZ', 'name': 'Uzbekistan' },
  { 'code': 'VU', 'name': 'Vanuatu' },
  { 'code': 'VE', 'name': 'Venezuela' },
  { 'code': 'VN', 'name': 'Vietnam' },
  { 'code': 'VG', 'name': 'Virgin Islands, British' },
  { 'code': 'VI', 'name': 'Virgin Islands, U.S.' },
  { 'code': 'WF', 'name': 'Wallis and Futuna' },
  { 'code': 'EH', 'name': 'Western Sahara' },
  { 'code': 'YE', 'name': 'Yemen' },
  { 'code': 'ZM', 'name': 'Zambia' },
  { 'code': 'ZW', 'name': 'Zimbabwe' }
]
const US_STATES = [
  { 'code': 'AL', 'name': 'Alabama' }, { 'code': 'AK', 'name': 'Alaska' },
  {
    'code': 'AZ',
    'name': 'Arizona'
  }, { 'code': 'AR', 'name': 'Arkansas' }, { 'code': 'CA', 'name': 'California' }, {
    'code': 'CO',
    'name': 'Colorado'
  }, { 'code': 'CT', 'name': 'Connecticut' }, { 'code': 'DE', 'name': 'Delaware' }, {
    'code': 'DC',
    'name': 'DistrictofColumbia'
  }, { 'code': 'FL', 'name': 'Florida' }, { 'code': 'GA', 'name': 'Georgia' }, {
    'code': 'HI',
    'name': 'Hawaii'
  }, { 'code': 'ID', 'name': 'Idaho' }, { 'code': 'IL', 'name': 'Illinois' }, {
    'code': 'IN',
    'name': 'Indiana'
  }, { 'code': 'IA', 'name': 'Iowa' }, { 'code': 'KS', 'name': 'Kansas' }, { 'code': 'KY', 'name': 'Kentucky' }, {
    'code': 'LA',
    'name': 'Louisiana'
  }, { 'code': 'ME', 'name': 'Maine' }, { 'code': 'MD', 'name': 'Maryland' }, {
    'code': 'MA',
    'name': 'Massachusetts'
  }, { 'code': 'MI', 'name': 'Michigan' }, { 'code': 'MN', 'name': 'Minnesota' }, {
    'code': 'MS',
    'name': 'Mississippi'
  }, { 'code': 'MO', 'name': 'Missouri' }, { 'code': 'MT', 'name': 'Montana' }, {
    'code': 'NE',
    'name': 'Nebraska'
  }, { 'code': 'NV', 'name': 'Nevada' }, { 'code': 'NH', 'name': 'NewHampshire' }, {
    'code': 'NJ',
    'name': 'NewJersey'
  }, { 'code': 'NM', 'name': 'NewMexico' }, { 'code': 'NY', 'name': 'NewYork' }, {
    'code': 'NC',
    'name': 'NorthCarolina'
  }, { 'code': 'ND', 'name': 'NorthDakota' }, { 'code': 'OH', 'name': 'Ohio' }, {
    'code': 'OK',
    'name': 'Oklahoma'
  }, { 'code': 'OR', 'name': 'Oregon' }, { 'code': 'PA', 'name': 'Pennsylvania' }, {
    'code': 'PR',
    'name': 'PuertoRico'
  }, { 'code': 'RI', 'name': 'RhodeIsland' }, { 'code': 'SC', 'name': 'SouthCarolina' }, {
    'code': 'SD',
    'name': 'SouthDakota'
  }, { 'code': 'TN', 'name': 'Tennessee' }, { 'code': 'TX', 'name': 'Texas' }, { 'code': 'UT', 'name': 'Utah' }, {
    'code': 'VT',
    'name': 'Vermont'
  }, { 'code': 'VA', 'name': 'Virginia' }, { 'code': 'WA', 'name': 'Washington' }, {
    'code': 'WV',
    'name': 'WestVirginia'
  }, { 'code': 'WI', 'name': 'Wisconsin' }, { 'code': 'WY', 'name': 'Wyoming' }]

const MARITAL_STATUS = [{ 'code': 'single', 'name': 'Single' }, {
  'code': 'married',
  'name': 'Married'
}, { 'code': 'widowed', 'name': 'Widowed' }, { 'code': 'divorced', 'name': 'Divorced' }, {
  'code': 'separated',
  'name': 'Separated'
}]
const EMPLOYED_STATUS = [{ 'code': 'employed', 'name': 'Yes' }, { 'code': 'nonemployed', 'name': 'No' }]
const RELATIONSHIP_STATUS = [{ 'code': 'mother', 'name': 'Mother' }, {
  'code': 'father',
  'name': 'Father'
}, { 'code': 'spouse', 'name': 'Spouse' }, { 'code': 'son', 'name': 'Son' }, {
  'code': 'daughter',
  'name': 'Daughter'
}, { 'code': 'other', 'name': 'Other' }]
const ETHNICITY = ['White', 'Hispanic or Latino', 'Black or African American', 'Native American or American Indian', 'Asian / Pacific Islander', 'Others', 'Prefer Not to Answer']
let YEARS = []
let MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
let DAYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
for (let i = 0, y = (new Date()).getFullYear(); i < 100; ++i) {
  YEARS[YEARS.length] = y - i
}
const ROUTE_DATA = [

]
const FREQUENCY_DATA = [

]

const INFOFORMDELETE = {
  contentDeleteForm: 'Are you sure to delete this record',
  isShowFormDelete: true
}
const PLACE_OF_SERVICES = [

]
const ROUTE = [

]

const UNIT_DISPENSE_2 = ['not specified', 'tablet', 'capsule', 'gram', 'milliliter', 'applicator', 'blister', 'caplet', 'film', 'gum', 'implant', 'insert', 'kit Unit', 'lancet', 'lozenge', 'patch', 'packet', 'pad', 'pen needle', 'ring', 'sponge', 'stick', 'strip', 'suppository', 'swab', 'troche', 'wafer', 'each']

const FREQUENCY = [
  { value: '1;1', name: 'as directed', desc: 'AS DIRECTED' },
  { value: '2;30', name: 'DAILY', desc: 'EVERY DAY' },
  { value: '5;60', name: 'BID', desc: 'TWICE A DAY' },
  { value: '6;90', name: 'TID', desc: 'THREE TIME A DAY' },
  { value: '7;120', name: 'QID', desc: 'FOUR TIME A DAY' },
  { value: '25;480', name: 'Q1h WA', desc: 'Every hour while awake' },
  { value: '13;240', name: 'Q2h WA', desc: 'Every 2 hours while awake' },
  { value: '8;180', name: 'Q4h', desc: 'Every 4 hours' },
  { value: '29;360', name: 'Q2h', desc: 'Every 2 hours' },
  { value: '28;240', name: 'Q3h', desc: 'Every 3 hours' },
  { value: '24;180', name: 'Q4-6h', desc: 'Every 4-6 hours' },
  { value: '9;120', name: 'Q6h', desc: 'Every 6 hours' },
  { value: '31;120', name: 'Q6-8h', desc: 'Every 6-8 hours' },
  { value: '10;90', name: 'Q8h', desc: 'Every 8 hours' },
  { value: '30;90', name: 'Q8-12h', desc: 'Every 8-12 hours' },
  { value: '11;60', name: 'Q12h', desc: 'Every 12 hours' },
  { value: '26;15', name: 'Q48h', desc: 'Every 48 hours' },
  { value: '23;10', name: 'Q72h', desc: 'Every 72 hours' },
  { value: '18;30', name: 'Q72h', desc: 'Every 72 hours' },
  { value: '19;30', name: 'QHS', desc: 'Before bedtime' },
  { value: '4;30', name: 'in A.M.', desc: 'Every morning' },
  { value: '12;15', name: 'EVERY OTHER DAY', desc: 'Every other day' },
  { value: '27;8.57', name: '2 times weekly', desc: '2 times weekly' },
  { value: '20;12.86', name: '3 times weekly', desc: '3 times weekly' },
  { value: '14;4', name: 'Q1wk', desc: 'Every 1 week' },
  { value: '15;2', name: 'Q2wks', desc: 'Every 2 weeks' },
  { value: '16;1.43', name: 'Q3wks', desc: 'Every 3 weeks' },
  { value: '22;1', name: 'Once a month', desc: 'Every month' },
  { value: '17;1', name: "Add'l Sig", desc: "Add'l Sig" }
]
const DO_NOT_RUN_INTERVAL = true
export default {
  baseUrl: 'https://sales.wikiallergies.com/v1',
  mainUrl: 'https://sales.wikiallergies.com',
  wikiUrl: 'https://wikiallergies.com',
  MARITAL_STATUS: MARITAL_STATUS,
  RELATIONSHIP_STATUS: RELATIONSHIP_STATUS,
  DAYS: DAYS,
  MONTHS: MONTHS,
  YEARS: YEARS,
  ETHNICITY: ETHNICITY,
  STATE: US_STATES,
  COUNTRY: COUNTRY,
  EMPLOYED_STATUS: EMPLOYED_STATUS,
  ROUTE_DATA: ROUTE_DATA,
  ROUTE: ROUTE,
  FREQUENCY_DATA: FREQUENCY_DATA,
  UNIT_DISPENSE: UNIT_DISPENSE_2,
  INFO_FORM_DELETE: INFOFORMDELETE,
  PLACE_OF_SERVICES: PLACE_OF_SERVICES,
  DO_NOT_RUN_INTERVAL: DO_NOT_RUN_INTERVAL,
  FREQUENCY: FREQUENCY
}
